import AbstractProvidedClass from "../../../../shared/AbstractProvidedClass";
import { CHANGE_SPECIES_LABEL, REMOVE_SPECIES_FROM_ELEMENT } from "../../../../tools/actions/ActionHelper";
import EventTypes from "../../../../shared/EventTypes";
import { addSvg } from "../../../../shared/utils";
import RowHelper from "../../RowHelper";
import NewLabelButton from "./NewLabelButton";

export default class SpeciesLabelField extends AbstractProvidedClass {
    optionsOpen = false;

    constructor(provider, label, container) {
        super(provider);

        this.label = label;
        this.species = this.speciesCollection.get(label.id);

        this.createField(container);
        this.updateLabel();
        this.helper = new RowHelper(provider, this);
        this.helper.createOptions(['edit', 'remove', 'info']);

        label.keys.map(key => this.addKey(key));

        if (this.touch) {
            this.moreButton = this.p.createDiv()
                .parent(this.row)
                .class('btn-icon')
                .style('margin-left', 'auto')
                .mouseClicked(() => this.toggleRowOptions());
            addSvg(this.moreButton, 'more-2-fill');
            this.on(EventTypes.CLOSE_SIDEBAR, () => this.closeRowOptions());
        }

        this.on(EventTypes.UPDATE_ELEMENT_LABELS, (element) => {
            if (element == this.label.parent.parent) {
                this.updateLabel();
            }
        })
    }

    createField(container) {
        this.labelContainer = this.p.createDiv()
            .parent(container)
            .id('species-row-' + this.species.id)
        container.elt.appendChild(this.labelContainer.elt);
        this.row = this.p.createDiv()
            .parent(this.labelContainer)
            .class('input-search-result')
            .mouseOver(() => this.mouseOver())
            .mouseOut(() => this.mouseOut());

        this.img = this.p.createImg(this.species.thumb || '/permapeople-permaculture-plant-database-blank.jpg')
            .parent(this.row)
            .class('data-img-xs move-icon')
            .style('margin', 'auto 0');

        this.speciesLabel = this.p.createElement('label', '')
            .class('input-search-result-name')
            .parent(this.row);

        this.labelOptionsContainer = this.p.createDiv()
            .parent(this.labelContainer)
            .class('input-group -has-checkbox');
        let labelOpts = this.species.type !== 'Variety'
            ? ['name', 'scientific_name']
            : ['name', 'scientific_name', 'parent_name'];
        this.labelOptions = {};
        labelOpts.forEach(key => {
            this.labelOptions[key] = this.createLabelOption(key);
        });
        this.labelOptionsContainer.hide();

        if (!this.touch) {
            this.newCustomLabelButton = new NewLabelButton(
                this.provider,
                this.labelContainer,
                this.label.parent,
                this.label.index + 1,
                container
            );
        }
    }

    createLabelOption(key) {
        let checkbox = this.p.createCheckbox(this.species[key], false)
            .parent(this.labelOptionsContainer)
            .changed(() => this.action?.update(key, checkbox.checked()));
        return checkbox;
    }

    updateLabel() {
        let nameActivity = this.label.keys.includes('name') ? 'active' : 'inactive';
        let sciNameActivity = this.label.keys.includes('scientific_name') ? 'active' : 'inactive';
        let parentNameActivity = this.label.keys.includes('parent_name') ? 'active' : 'inactive';
        if (this.species.type !== 'Variety') {
            this.speciesLabel.html(`
                <div class="${nameActivity}">${this.species.name}</div>
                <span class="${sciNameActivity}">
                ${this.species.scientific_name}
                </span>
            `);
        } else {
            this.row.style('height', '75px');
            this.speciesLabel.html(`
                <div class="${nameActivity}">${this.species.name}</div>
                <span class="${sciNameActivity}">
                ${this.species.scientific_name}
                </span><span class="${parentNameActivity}">
                ${this.species.parent_name}
                </span>
            `);
        }
    }

    addKey(key) {
        this.labelOptions[key].checked(true);
    }

    delete() {
        this.labelContainer.remove();
    }

    drag() {
        this.mouseOut();
        this.closeEditOptions();
        this.closeRowOptions();
        this.dragging = true;
    }

    endDrag() {
        this.dragging = false;
    }

    mouseOver() {
        if (this.dragging || this.touch) return;
        this.speciesInfo.setSpecies(this.species);
        this.speciesLabel.hide();
        this.options.show();
    }

    mouseOut() {
        if (this.dragging || this.touch) return;
        this.speciesInfo.setSpecies(null);
        this.speciesLabel.show();
        this.options.hide();
    }

    openRowOptions() {
        this.speciesLabel.hide();
        this.moreButton?.hide();
        this.options.show();
        this._closeHandler = (e) => {
            if (!this.labelContainer.elt.contains(e.target)) {
                this.closeRowOptions();
            }
        };
        setTimeout(() => document.addEventListener('touchstart', this._closeHandler), 0);
    }

    closeRowOptions() {
        if (this._closeHandler) {
            document.removeEventListener('touchstart', this._closeHandler);
            this._closeHandler = null;
        }
        this.closeEditOptions();
        this.speciesLabel.show();
        this.moreButton?.show();
        this.options.hide();
    }

    toggleRowOptions() {
        if (this.options.elt.style.display === 'none') {
            this.openRowOptions();
        } else {
            this.closeRowOptions();
        }
    }

    toggleEdit() {
        this.optionsOpen ? this.closeEditOptions() : this.openEditOptions();
    }

    openEditOptions() {
        this.action = this.actions.new(CHANGE_SPECIES_LABEL, this.label);
        this.labelOptionsContainer.show();
        this.optionsOpen = true;
    }

    closeEditOptions() {
        this.action?.finish();
        this.action = null;
        this.labelOptionsContainer.hide();
        this.optionsOpen = false;
    }

    remove() {
        this.actions.execute(REMOVE_SPECIES_FROM_ELEMENT, this.selection.first, this.species);
        this.speciesInfo.setSpecies(null);
        this.delete();
    }
}
